import styled from "@emotion/styled";

import { getBadgeSizeStyles, getBadgeVariantStyles } from "./badge-styles";
import type { StyledBadgeProps } from "./types";

export const StyledBadge = styled.span<StyledBadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: ${({ $styleProps }) => $styleProps?.fontWeight ?? 600};
  border-radius: ${({ $styleProps }) => $styleProps?.borderRadius ?? "9999px"};
  user-select: none;
  white-space: nowrap;
  font-size: ${({ $styleProps }) => $styleProps?.fontSize ?? "inherit"};
  padding: ${({ $styleProps }) => $styleProps?.padding ?? "0"};
  margin: ${({ $styleProps }) => $styleProps?.margin ?? "0"};

  ${({ $size = "medium", $styleProps }) => {
    // If custom padding is provided, don't use default size styles
    if ($styleProps?.padding) return "";
    return getBadgeSizeStyles($size);
  }}

  ${({ $variant = "solid", $styleProps }) =>
    getBadgeVariantStyles($variant, $styleProps)}
`;
